import { Component, input } from '@angular/core';
import { MtrFormFieldModule } from '@mortar/angular/components/atomic/form-field';
import { MteFormatDateWrapper } from '@mortar/angular/elements/utilities/format-date';
import { DisplayComponent } from 'app/driver-pay/persistence/core/components/displays/DisplayComponent';

@Component({
  selector: 'iso-instant-as-local-datetime-display',
  template: `
    @if (value() !== null && value() !== undefined) {
      <mte-format-date
        id="{{ id() ?? value()?.toString() }}"
        [date]="value()?.toString() ?? ''"
        year="numeric"
        month="numeric"
        day="numeric"
        hour="numeric"
        minute="numeric"
        timeZoneName="short"
        hourFormat="24" />
    }
  `,
  standalone: true,
  imports: [MtrFormFieldModule, MteFormatDateWrapper],
})
export class IsoInstantAsLocalDateTimeDisplayComponent implements DisplayComponent {
  id = input<string>();
  value = input.required<object | undefined>();
}
